import {cabinetNotificationsApi} from "./cabinetNotifications";

export * from "./cabinetNotifications";
export type {
    CabinetNotification as MerchantNotification,
    CabinetNotificationSettings as MerchantNotificationSettings,
    CabinetNotificationsPage as MerchantNotificationsPage,
} from "./cabinetNotifications";

/** Группы событий в порядке показа. */
export const NOTIFICATION_GROUP_KEYS = [
    "order_created",
    "requisites",
    "success",
    "cancel",
    "balance",
] as const;

const api = cabinetNotificationsApi("/merchant/me/notifications");

export const listMerchantNotifications = api.list;
export const markMerchantNotificationsSeen = api.markSeen;
export const getMerchantNotificationSettings = api.getSettings;
export const saveMerchantNotificationSettings = api.saveSettings;
export const createMerchantTelegramLink = api.createLink;
export const revokeMerchantTelegramLink = api.revokeLink;
export const testMerchantTelegram = api.testTelegram;
export const disconnectMerchantTelegramChat = api.disconnectChat;
